import { WEB_LIGHT_THEME, WEB_DARK_THEME, type renderCssVariables } from '@vello/tokens';
import { velloThemeCss } from './theme-css';
import { enableDarkTheme } from './theme-preference';

/** The theme token set to inject (defaults to the web light theme — the Vello Claude Design's default surface). */
type ThemeTokens = Parameters<typeof renderCssVariables>[0];

/**
 * Install the Vello design system at boot: inject the token custom properties on `:root` plus the effect layer
 * (FX-01…16) into a single `<style id="vello-theme">`. This is the ONE way every Vello web app applies the
 * design — call it once in the app entry, next to `import '@vello/web-theme/theme.css'` and `.../fonts.css`.
 * Idempotent (safe under React StrictMode double-invoke and hot reload) and a no-op outside the browser.
 *
 * D798: `{ dark: true }` adds the dark surface (`WEB_DARK_THEME`, the native apps' navy). It is switched on by the console
 * shell only, after sign-in (`useConsoleTheme`, `theme-preference.ts`); sign-in screens stay light. Without it the page is
 * light only.
 */
export function installVelloTheme(theme: ThemeTokens = WEB_LIGHT_THEME, options: { readonly dark?: boolean } = {}): void {
  if (typeof document === 'undefined') return;
  if (options.dark === true) enableDarkTheme();
  if (document.getElementById('vello-theme') !== null) return;
  const style = document.createElement('style');
  style.id = 'vello-theme';
  style.textContent = velloThemeCss(theme, options.dark === true ? WEB_DARK_THEME : undefined);
  document.head.appendChild(style);
}
